module.exports = __webpack_public_path__ + "img/ISO14001-2015.db815b9d.jpg";